import { h, Component } from 'preact';
import { jsxIf } from 'utils/jsx.util';
import NMServiceRequestForm from 'components/nm_service_request_form.component';
import NMLeadForm from 'components/nm_lead_form.component';
import { directCall } from '../analytics/dtm_helper';

export default class NMAgentFormComponent extends Component {
  analyticsFlowNames = { // form flow analytics names that map to form field names for adobe shared calls on lead and service request forms
    first_name: 'First Name',
    last_name: 'Last Name',
    zip: 'Zip',
    phone: 'Phone',
    email: 'Email',
    comments: 'Comments',
    wealth_range: 'Wealth Range',
    income_range: 'Income Range',
    goal: 'Goal',
    age: 'Age',
  }

  constructor() {
    super();
    this.state = {
      // used to pass information back and forth between the service request and lead forms.
      // also used to help submit the lead and service request forms because switching back and forth on these forms on the
      // profile page breaks the state, so we use these fields instead
      agentForm: {
        sc_visitor_id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        comments: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        campaign_name: '',
        age: '',
        goal: '',
        income_range: '',
        wealth_range: '',
      },

      policyOwner: false,
      isShowingThankYou: false,
      isShowingError: false,

      recaptchaIds: {
        leadFormId: '',
        serviceRequestId: '',
      },
    };
  }

  handleIsPolicyOwnerChange (event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    const actionInfo = {
      'action-type': 'Are You Currently Working Together',
      'action-keys': `fr-${this.props.formLocation}-fill-nmx`, // formLocation is either "dir" or "profile"
      'action-values': 'Completed',
    };
    directCall('shared-call', actionInfo);

    this.setState({ policyOwner: value });
  }

  handleIsShowingThankYouChange (value) {
    this.setState({ isShowingThankYou: value });
  }

  handleIsShowingErrorChange (value) {
    this.setState({ isShowingError: value });
  }

  handleIsShowingPolicyOwnerErrorChange (value) {
    this.setState({ policyOwnerError: value });
  }

  render () {
    if (this.state.isShowingThankYou) {
      return (
        <div class='general-thank-you'>
          <img
            src='<%=templateBasePath%>/images/success-icon.svg'
            alt='Person in Cicle with Checkmark'
            title='Success'
          />
          <h3>Thank you.</h3>
          {jsxIf(
            this.state.policyOwner === 'Yes',
            () => <h4>Your financial advisor will get back to you soon.</h4>,
            () => <h4>Your financial advisor will get back to you soon.</h4>,
          )}
        </div>
      );
    } if (this.state.isShowingError) {
      return (
        <div class='general-content is-wide'>
          <h3>
            Unable to submit form.
          </h3>
          <p>
            Please try again later.
          </p>
        </div>
      );
    } return (
      // TODO Don't have form tag in the future
      <div>
        <div className='general-form'>
          <div className='row'>
            <div class='column'>
              <div class='general-form--input' role='radiogroup' aria-label='are you currently working together' >
                Are you currently working together?<sup
                  className='required'
                  aria-required='true'
                >
                  *
                </sup>
                <label aria-label='Yes' class='is-inline'>
                  Y
                  <input
                    type='radio'
                    name='policyOwner'
                    value='Yes'
                    onChange={this.handleIsPolicyOwnerChange.bind(this)}
                  />
                </label>
                <label aria-label='No' class='is-inline'>
                  N
                  <input
                    type='radio'
                    name='policyOwner'
                    value='No'
                    onChange={this.handleIsPolicyOwnerChange.bind(this)}
                  />
                </label>
                {jsxIf(this.state.policyOwnerError, () => (
                  <div class='general-form--notice'>{this.state.policyOwnerError}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
        {jsxIf(
          this.state.policyOwner === 'Yes',
          () => <NMServiceRequestForm
            recaptchaIds={this.state.recaptchaIds}
            policyOwner={this.state.policyOwner} // needed for form validation
            isShowingPolicyOwnerError={this.handleIsShowingPolicyOwnerErrorChange.bind(this)} // needed for form validation
            agentNumber={this.props.agentnumber} // needed for the lead system on the backend
            formLocation={this.props.formlocation} // needed for analytics direct call rule
            isShowingThankYou={this.handleIsShowingThankYouChange.bind(this)} // needed to show the thank you text
            isShowingError={this.handleIsShowingErrorChange.bind(this)} // needed to show error text
            campaign={this.props.campaign} // campaign name for form
            agentForm={this.state.agentForm}
            analyticsFlowNames={this.analyticsFlowNames}
          />,
          () => <NMLeadForm
            recaptchaIds={this.state.recaptchaIds}
            policyOwner={this.state.policyOwner} // needed for form validation
            isShowingPolicyOwnerError={this.handleIsShowingPolicyOwnerErrorChange.bind(this)} // needed for form validation
            agentNumber={this.props.agentnumber} // needed for the lead system on the backend
            formLocation={this.props.formlocation} // needed for analytics direct call rule
            isShowingThankYou={this.handleIsShowingThankYouChange.bind(this)} // needed to show the thank you text
            isShowingError={this.handleIsShowingErrorChange.bind(this)} // needed to show error text
            campaign={this.props.campaign} // campaign name for form
            agentForm={this.state.agentForm}
            analyticsFlowNames={this.analyticsFlowNames}
            floodlightsendto={this.props.floodlightsendto}
          />,
        )}
      </div>
    );
  }
}
